<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shadcn-lib/utils";
import { inject, computed } from "vue";

interface AccordionContext {
  type: "single" | "multiple";
  value: import("vue").Ref<string[]>;
  onValueChange: (value: string[]) => void;
  collapsible?: boolean;
}

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();

const context = inject<AccordionContext>("accordion-context");
const itemContext = inject<{
  value: string;
  open: import("vue").ComputedRef<boolean>;
  disabled?: boolean;
}>("accordion-item-context");

const open = computed(() => {
  if (!context || !itemContext) return false;
  return context.value.value.includes(itemContext.value);
});
</script>

<template>
  <div
    data-slot="accordion-content"
    :data-state="open ? 'open' : 'closed'"
    :class="
      cn(
        'overflow-hidden overflow-y-auto text-sm transition-all duration-200 ease-in-out',
        open ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0',
        props.class
      )
    "
  >
    <div class="pt-0 pb-4">
      <slot />
    </div>
  </div>
</template>
